import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import queryString from 'query-string';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import Grid from '@material-ui/core/Grid';
import { ja } from 'date-fns/locale';
import DateFnsUtils from '@date-io/date-fns';
import Header from '../../components/Header';
import SearchButton from '../../components/atoms/SearchButton';
import InvoiceShopButton from '../../components/atoms/InvoiceShopButton';
import InvoiceHistoryShopButton from '../../components/atoms/InvoiceHistoryShopButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import InvoiceGochiTable from '../organisms/InvoiceGochiTable';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getInvoiceShop, confirmInvoiceShop } from '../../actions/Shop';
import { getAccounts } from '../../actions/Accounts';

const styles = theme => ({
  root: {
    backgroundColor: '#F7F7F7',
    flexGrow: 1,
    width: '100%',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    [theme.breakpoints.up('sm')]: {
      maxWidth: 375,
      backgroundColor: '#F7F7F7',
      margin: '0 auto'
    }
  },
  rootClassic: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  mainContent: {
    padding: 15
  },
  pageTitileDiv: {
    textAlign: 'left',
    marginBottom: 10
  },
  mainPaper: {
    position: 'relative'
  },
  zoom: {
    position: 'relative',
    left: -10,
    top: 20
  },
  mainPaperTitleDiv: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px 26px 10px 26px'
  },
  searchForm: {
    padding: '10px 20px 20px 20px',
    display: 'block',
    height: '68px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '100%',
    marginTop: 0
  },
  textField150: {
    padding: '0px 5px 0px 5px',
    width: '200px'
  },
  textField300: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  button: {
    margin: '5px 5px'
  },
  boxLeft: {
    textAlign: 'left',
    float: 'left',
    height: '68px'
  },
  buttonLeft: {
    textAlign: 'left',
    float: 'left'
  },
  buttonRight: {
    textAlign: 'right',
    float: 'right'
  },
  fs24: {
    fontSize: '24px'
  },
  fs20: {
    fontSize: '20px'
  },
  buttonCenter: {
    padding: '10px',
    textAlign: 'center'
  },
  gochiBox: {
    padding: 12,
    borderTop: '1px solid #DBDBDB'
  },
  gochiHeader: {
    padding: '10px',
    color: '#ffffff',
    fontSize: 12,
    textAlign: 'center',
    backgroundColor: '#717171',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    position: 'relative',
    marginBottom: 20,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',

    '&:before': {
      content: '""',
      position: 'absolute',
      left: '50%',
      bottom: '-12px',
      transform: 'translateY(-50%)',
      display: 'inline-block',
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '8px 5px 0 5px',
      borderColor: '#717171 transparent transparent transparent'
    }
  },
  couponNo: {
    margin: '0 20px',
    fontSize: 19,
    fontWeight: 'bold',
    lineHeight: '22px',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  textCompare: {
    display: 'inline-block',
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  },
  remainCoupon: {
    backgroundColor: '#FFD0D5',
    color: '#000000',

    '&:before': {
      borderColor: '#FFD0D5 transparent transparent transparent'
    }
  },
  gochiCoupon: {
    backgroundColor: '#fffbd0',
    color: '#000000',

    '&:before': {
      borderColor: '#fffbd0 transparent transparent transparent'
    }
  },
  inputRoot: {
    width: '100%'
  },
  inputMessage: {
    borderColor: '#DBDBDB',
    borderRadius: 0,
    padding: '10px 15px',
    height: 70,
    fontSize: 12
  },
  buttonSend: {
    marginLeft: 'auto',
    height: 22,
    fontSize: 12,
    padding: 0
  },
  messageReplyBox: {
    backgroundColor: '#F7F7F7',
    borderRadius: 6,
    padding: '8px 10px',
    whiteSpace: 'pre-line'
  },
  textRedBig: {
    color: '#F50357'
  },
  textRight: {
    textAlign: 'right',
    paddingRight: '50px',
    marginBottom: '30px'
  },
  textRed: {
    color: '#F1226D'
  },
  textId: {
    fontSize: 10,
    color: '#777777',
    display: 'inline-block',
    marginLeft: 5
  },
  textCenter: {
    textAlign: 'center',
    marginTop: 15
  },
  searchCollapseBox: {
    marginBottom: '20px'
  },
  collapseBtn: {
    minHeight: 'unset !impotant',
    margin: '0',
    padding: 0
  },

  extendClasses: {
    margin: 0
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          confirmInvoiceShop,
          getInvoiceShop
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openTable', 'updateOpenTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('totalTransferAmount', 'setTotalTransferAmount', []),
  withState('isConfirmable', 'setIsConfirmable', []),
  withState('childKey', 'setChildKey', 0),
  withState('perPage', 'setPerPage', 10),
  withState('page', 'setPage', 1),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('defaultMonth', 'setDefaultMonth', () => {
    const newDate = new Date();
    return newDate.setMonth(newDate.getMonth() - 1);
  }),
  withState('monthConfirm', 'setMonthConfirm', () => {
    const newDate = new Date();
    return newDate.setMonth(newDate.getMonth() - 1);
  }),
  withState('openConfirm', 'updateOpenConfirm', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    },
    getMonthYear: () => timestamp => {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const mon =
        date.getMonth() >= 9 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`;
      console.log('month day', mon);
      console.log('month day', year);
      return year.toString() + mon.toString();
    },
    handleChangePage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }

      const rowsPerPage = document.getElementById('rowsPerPage');
      let limitNum = 100;
      if (rowsPerPage) {
        limitNum = rowsPerPage.textContent;
      }
      const dateMonth = new Date(props.defaultMonth);
      const year = dateMonth.getFullYear();
      const mon =
        dateMonth.getMonth() >= 9
          ? dateMonth.getMonth() + 1
          : `0${dateMonth.getMonth() + 1}`;
      const searchKey = {
        month: year.toString() + mon.toString(),
        page,
        limit: limit || limitNum
      };

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions
        .getInvoiceShop(searchKey)
        .then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        })
        .catch(() => {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
        });
      props.setPage(page);
    },
    handleChangeMonth: props => e => {
      if (e !== '') {
        props.setDefaultMonth(e);
      }
    }
  }),
  lifecycle({
    async componentDidMount() {
      this.props.setChildKey(this.props.childKey + 1);
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' });
    },
    componentUnmount() {
      const list = [{ foo: undefined }];
      this.props.setTotalTransferAmount(list);
      console.log(this.props.totalTransferAmount);
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    handleChangePage,
    account,
    updateOpenDrawer,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    handleRedirect,
    totalTransferAmount,
    setPage,
    openTable,
    updateOpenTable,
    page,
    defaultMonth,
    handleChangeMonth,
    openConfirm,
    updateOpenConfirm,
    getMonthYear,
    setTotalTransferAmount,
    isConfirmable,
    setIsConfirmable,
    monthConfirm,
    setMonthConfirm
  }) => {
    const isShop = typeof account !== 'undefined' && account.role === 'SHOP';
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isDeveloper =
      typeof account !== 'undefined' && account.role === 'DEVELOPER';
    const roles = {
      isShop,
      isGroup,
      isSecretariat,
      isDeveloper
    };

    const rowsPerPage = document.getElementById('rowsPerPage');
    let limit = 100;
    if (rowsPerPage) {
      limit = rowsPerPage.textContent;
    }

    let searchKey = {
      month: getMonthYear(defaultMonth),
      limit
    };

    const isReleased =
      account && account.accountStatus && account.accountStatus.status === true;

    const para = queryString.parse(window.location.search);
    // check if is account shop
    if (!isShop && !isReleased && !para.notify) {
      console.log('isShop', isShop);
      console.log('isReleased', isReleased);
      console.log('para.notify', para.notify);
      handleRedirect('/shops');
    }

    const searchActionClassic = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      setPage(1);
      searchKey = {
        ...searchKey
      };
      await actions
        .getInvoiceShop(searchKey)
        .then(data => {
          checkSession(data);
          updateOpenProgress(false);
          setResultMessage('');
          updateLoading(false);
          updateOpenTable(true);
          setTotalTransferAmount(data.payload.totalTransferAmount);
          setIsConfirmable(data.payload.isConfirmable);
          setMonthConfirm(defaultMonth);
        })
        .catch(() => {
          updateOpenProgress(false);
          setResultMessage('');
          updateLoading(false);
        });
    };

    const confirmInvoice = async () => {
      updateOpenConfirm(false);
      updateLoading(true);
      updateOpenProgress(true);
      await actions
        .confirmInvoiceShop({ month: getMonthYear(defaultMonth) })
        .then(data => {
          checkSession(data);
          if (data.type === 'CONFIRM_INVOICE_SHOP_SUCCESS') {
            setResultMessage(data.payload.completeMessage);
            updateLoading(false);
            setIsConfirmable(false);
          } else if (data.payload.status && data.payload.status === 423) {
            setResultMessage(
              '「請求を確定させる」ボタンは、請求月翌月1日から5営業日で押下ください'
            );
            updateLoading(false);
            setIsConfirmable(false);
          } else {
            setResultMessage('エラーが発生しました！');
            updateLoading(false);
          }
        })
        .catch(e => {
          console.log('error confirm invoice', e);
          updateOpenProgress(true);
          setResultMessage('エラーが発生しました！');
          updateLoading(false);
        });
    };

    useEffect(() => {
      searchActionClassic();
    }, []);

    const progressOkAction = () => {
      updateOpenProgress(false);
    };

    return (
      <>
        <div className={classes.rootClassic}>
          <Header
            onMenuClick={() => {
              updateOpenDrawer(true);
            }}
          />

          <div className={classes.mainContent}>
            <div className={classes.pageTitileDiv}>
              <Typography color="textPrimary" className={classes.fs24}>
                請求情報管理
              </Typography>
            </div>
            <Paper className={classes.mainPaper} elevation={1}>
              <div className={classes.searchForm}>
                <div className={classes.boxLeft}>
                  <div className={classes.buttonLeft}>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={ja}
                      libInstance={moment}
                    >
                      <Grid container justify="space-around">
                        <DatePicker
                          variant="inline"
                          openTo="year"
                          format="y年M月"
                          views={['year', 'month']}
                          // label="Year and Month"
                          // helperText="Start from year selection"
                          maxDate={new Date()}
                          value={defaultMonth}
                          onChange={handleChangeMonth}
                        />
                      </Grid>
                    </MuiPickersUtilsProvider>
                  </div>
                  <div className={classes.buttonLeft}>
                    <SearchButton onClickAction={searchActionClassic} />
                  </div>
                </div>
                <div className={classes.buttonRight}>
                  <InvoiceHistoryShopButton
                    onClickAction={() => handleRedirect('invoice_history_shop')}
                    message="請求確定履歴画面へ"
                  />
                </div>
              </div>
              <div>
                <Typography color="textPrimary" className={classes.textRight}>
                  {'合計金額: '}
                  {totalTransferAmount}
                  {totalTransferAmount ? '円' : ''}
                </Typography>
              </div>
              {openTable && (
                <InvoiceGochiTable
                  isShop
                  roles={roles}
                  page={page}
                  handleChangePage={handleChangePage}
                  selectedPage={page}
                />
              )}
              <div className={classes.searchForm}>
                <div className={classes.buttonRight}>
                  <InvoiceShopButton
                    onClickAction={confirmInvoice}
                    message="請求を確定させる"
                    monthInvoice={monthConfirm}
                    openConfirm={openConfirm}
                    updateOpenConfirm={updateOpenConfirm}
                    disabled={!isConfirmable}
                  />
                  <InvoiceHistoryShopButton
                    onClickAction={() =>
                      window.open('https://forms.gle/HcmKVXcSWXwWNuSD8')
                    }
                    message="修正を依頼する"
                  />
                </div>
              </div>
            </Paper>
            <ProgressDialog
              openProgress={openProgress}
              progressOkAction={progressOkAction}
              loading={loading}
              resultMessage={resultMessage}
            />
          </div>
        </div>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
